<template>
  <Modal :value="value" @hide="hide()" title="Delete package">
    <template slot="body" class="content">
      <div
        v-if="item.source.permission && item.source.permission < 16"
        class="notification is-danger"
      >
        This action requires <i>Delete</i> permission that you currently lack.
      </div>

      <p>
        Delete
        <i
          >{{ item.chocoPackage.Title || item.chocoPackage.Id }} -
          {{ item.chocoPackage.Version }}</i
        >
        from the repo <i>{{ item.source.name }}</i
        >. The package will be removed forever.
      </p>

      <div class="notification is-info">
        <p>
          This is a feature mainly for package testing, to be able to remove
          unused packages.
        </p>
        <p>
          You will still be able to uninstall this package from induvidual
          computers, if it is already installed.
        </p>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div @click="remove()" class="button is-danger">
          Delete
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { _delete, postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
    item: Object,
    sources: Array,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
  },
  data() {
    return {
      repoName: "",      
      isLoading: false,
    };
  },
  created() {},
  methods: {
    async remove() {
      this.isLoading = true;
      try {
        await _delete(
          `${this.item.source.url}package/${this.item.chocoPackage.Id}/${this.item.chocoPackage.Version}`
        );

        this.$emit("change", this.item);
        this.isLoading = false;
        this.hide();
      } catch (err) {
        console.log(err);
        if (err.response.status === 401)
          this.$helpers.notify("Permission denied", "", "danger");
        else this.$helpers.notify("Error", "Internal error", "danger");
      }

      this.isLoading = false;
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
